var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 512,
    viewBox: "0 0 1024 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 512,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_105_45)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0133057 0.0266647H682.787V512.027H-0.0133057V0.0266647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7931 155.535L145.813 49.045L163.562 60.8817L92.5415 167.372L74.7931 155.535ZM101.416 173.29L172.436 66.8001L190.184 78.6368L119.164 185.127L101.416 173.29ZM128.038 191.045L199.058 84.5551L216.807 96.3918L145.787 202.882L128.038 191.045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.257 415.942L536.277 309.452L554.026 321.289L483.005 427.779L465.257 415.942ZM491.88 433.697L562.9 327.207L580.648 339.044L509.628 445.534L491.88 433.697ZM518.502 451.452L589.522 344.962L607.271 356.799L536.251 463.289L518.502 451.452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.893 356.779L580.635 415.962Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.893 356.779L580.635 415.962",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.542 185.147C253.377 156.904 282.661 137.3 315.951 130.648C349.24 123.996 383.809 130.841 412.052 149.677C440.295 168.513 459.899 197.796 466.551 231.086C473.203 264.376 466.358 298.944 447.522 327.187L234.542 185.147Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.542 185.147C215.706 213.39 208.861 247.959 215.513 281.248C222.165 314.538 241.769 343.821 270.012 362.657C298.255 381.493 332.823 388.338 366.113 381.686C399.403 375.034 428.686 355.43 447.522 327.187C456.94 313.066 460.362 295.781 457.036 279.137C453.71 262.492 443.909 247.85 429.787 238.432C415.666 229.014 398.381 225.592 381.737 228.918C365.092 232.244 350.45 242.046 341.032 256.167L234.542 185.147Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.032 256.167C360.644 226.761 352.703 187.024 323.297 167.412C293.89 147.8 254.153 155.74 234.542 185.147C214.93 214.553 222.87 254.29 252.277 273.902C281.683 293.514 321.42 285.573 341.032 256.167Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.107 463.33L75.0866 356.839L92.8349 345.003L163.855 451.493L146.107 463.33ZM172.729 445.575L101.709 339.084L119.457 327.248L190.478 433.738L172.729 445.575ZM199.352 427.82L128.332 321.329L146.08 309.493L217.1 415.983L199.352 427.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.571 202.923L465.55 96.4324L483.299 84.5957L554.319 191.086L536.571 202.923ZM563.193 185.168L492.173 78.6774L509.921 66.8407L580.941 173.331L563.193 185.168ZM589.816 167.413L518.796 60.9224L536.544 49.0857L607.564 155.576L589.816 167.413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.782 395.289L159.405 377.534ZM492.186 155.596L523.246 134.882ZM549.869 117.127L576.491 99.3716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.782 395.289L159.405 377.534M492.186 155.596L523.246 134.882M549.869 117.127L576.491 99.3716",
    stroke: "white",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 512,
    fill: "url(#paint0_linear_105_45)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 512,
    fill: "url(#paint1_linear_105_45)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806.647 443V475H796V443C796 428.272 807.917 416.333 822.618 416.333C829.383 416.333 835.558 418.862 840.254 423.027C844.023 412.888 853.773 405.667 865.206 405.667C871.971 405.667 878.146 408.195 882.842 412.36C886.611 402.221 896.361 395 907.794 395C922.494 395 934.411 406.938 934.412 421.665C938.86 418.317 944.39 416.333 950.382 416.333C965.083 416.333 977 428.272 977 443V475H966.353V443C966.353 434.163 959.203 427 950.382 427C941.562 427 934.412 434.163 934.412 442.999V464.333H923.765V421.667C923.765 412.83 916.615 405.667 907.794 405.667C898.974 405.667 891.824 412.83 891.824 421.666V453.667H881.176V432.333C881.176 423.496 874.026 416.333 865.206 416.333C856.386 416.333 849.235 423.496 849.235 432.333V464.333H838.588V442.999C838.588 434.163 831.438 427 822.618 427C813.797 427 806.647 434.163 806.647 443V443ZM950.382 384.333C957.728 384.333 963.691 390.308 963.691 397.667C963.691 405.026 957.728 411 950.382 411C943.037 411 937.074 405.026 937.074 397.667C937.074 390.308 943.037 384.333 950.382 384.333ZM822.618 384.333C829.963 384.333 835.926 390.308 835.926 397.667C835.926 405.026 829.963 411 822.618 411C815.272 411 809.309 405.026 809.309 397.667C809.309 390.308 815.272 384.333 822.618 384.333ZM865.206 373.667C872.551 373.667 878.515 379.641 878.515 387C878.515 394.359 872.551 400.333 865.206 400.333C857.86 400.333 851.897 394.359 851.897 387C851.897 379.641 857.86 373.667 865.206 373.667ZM907.794 363C915.14 363 921.103 368.974 921.103 376.333C921.103 383.692 915.14 389.667 907.794 389.667C900.449 389.667 894.485 383.692 894.485 376.333C894.485 368.974 900.449 363 907.794 363V363Z",
    fill: "#F39C12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_45",
    x1: 0,
    y1: 0,
    x2: 491.453,
    y2: 655.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_105_45",
    x1: 563.5,
    y1: 235.5,
    x2: -12.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278654,
    stopColor: "#112A44",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_105_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682.667,
    height: 512,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.9ee64d2678ab64cde9edb83ac2953eaa.svg";
export { ForwardRef as ReactComponent };